import styled from "@emotion/styled";
import { ListItemButton } from "@mui/material";

/** Clickable row container shared by the news and community feed lists. */
export const FeedRowButton = styled(ListItemButton)(({ theme }) => ({
  alignItems: "flex-start",
  gap: theme.spacing(4),
  padding: theme.spacing(3, 0),
  "&:hover": {
    backgroundColor: "transparent",
  },
}));

/** Vertical text column inside a feed row. */
export const FeedRowContent = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
  flex: 1,
}));
